import React from 'react';
import { Container } from './styled';
import ProductsArea from '../../components/ProductsArea';


export default function Page() {
	return (
		<Container>
			<ProductsArea />
		</Container>
	)
}
